"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getActionableWaypoint = exports.filterReasonsByOrderType = void 0;
var types_1 = require("@bringg/types");
function filterReasonsByOrderType(reasons, taskTypeId) {
    if (!taskTypeId) {
        return reasons;
    }
    return reasons.filter(function (reason) {
        switch (reason.order_type) {
            case types_1.ReasonOrderType.PICKUP:
                return taskTypeId === types_1.TaskTypeId.PICKUP;
            case types_1.ReasonOrderType.DROPOFF:
                return taskTypeId === types_1.TaskTypeId.DELIVERY;
            case types_1.ReasonOrderType.PICKUP_AND_DROPOFF:
                return taskTypeId === types_1.TaskTypeId.PICKUP_AND_DELIVERY;
            case types_1.ReasonOrderType.CURBSIDE:
                return taskTypeId === types_1.TaskTypeId.CLICK_AND_COLLECT;
            default:
                return true;
        }
    });
}
exports.filterReasonsByOrderType = filterReasonsByOrderType;
function getActionableWaypoint(wayPoints, taskTypeId) {
    if (!(wayPoints === null || wayPoints === void 0 ? void 0 : wayPoints.length)) {
        return;
    }
    var actionableWayPoint = wayPoints.find(function (wayPoint) {
        if (wayPoint.hidden) {
            return;
        }
        switch (taskTypeId) {
            case types_1.TaskTypeId.PICKUP:
                return wayPoint.pickup_dropoff_option === types_1.PickupDropoffOption.PICKUP;
            case types_1.TaskTypeId.DELIVERY:
                return wayPoint.pickup_dropoff_option === types_1.PickupDropoffOption.DROPOFF;
            case types_1.TaskTypeId.PICKUP_AND_DELIVERY:
                return wayPoint.pickup_dropoff_option === types_1.PickupDropoffOption.BOTH;
            default:
                return;
        }
    });
    return actionableWayPoint || wayPoints.at(-1);
}
exports.getActionableWaypoint = getActionableWaypoint;
//# sourceMappingURL=task_utils.js.map